/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {PaginationState, sizePerPageList} from '../../_metronic/helpers'

type Props = {
  isLoading: boolean
  updateState: (state: any) => void
  pagination: PaginationState
}
export const Pagination = (props: Props) => {
  const {isLoading, updateState, pagination} = props
  const updatePage = (page_number: number | null) => {
    if (!page_number || isLoading || pagination.page_number === page_number) {
      return
    }

    updateState({page_number, page_size: pagination.page_size || 10})
  }
  const updatePageSize = (event: any) => {
    const page_size = event.target.value as PaginationState['page_size']

    if (!page_size || isLoading || pagination.page_size === page_size) {
      return
    }

    updateState({page_size, page_number: 1})
  }
  const paginationList = pagination.total ? Math.ceil(pagination.total / pagination.page_size) : 1
  let availablePaginationList = [...Array(paginationList)].map((item, i) => i)
  const ls = availablePaginationList.filter((a) => a > pagination.page_number - 4)
  const ls2 = ls.filter((a) => a < pagination.page_number + 2)
  return (
    <div className='flex flex-col md:flex-row md:justify-between items-center w-full gap-4'>
      <div className='flex items-center gap-4'>
        <select
          disabled={pagination.total === 0}
          className={clsx(
            'bg-gray-100 border border-gray-300 text-sm rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-primary transition',
            pagination.total === 0 && 'opacity-50 cursor-not-allowed'
          )}
          onChange={(e) => updatePageSize(e)}
          value={pagination.page_size}
        >
          {sizePerPageList.map((option) => {
            return (
              <option key={option} value={option}>
                {option}
              </option>
            )
          })}
        </select>

        <div className='text-sm font-medium text-gray-700'>
          Showing {pagination.page_number * pagination.page_size - pagination.page_size + 1} to{' '}
          {(pagination.page_number - 1) * pagination.page_size + (pagination.count || 1)} of{' '}
          {pagination.total} entries
        </div>
      </div>

      <div className='flex items-center justify-center'>
        <ul className='inline-flex items-center space-x-1 text-sm font-medium'>
          {/* First page */}
          <li>
            <button
              onClick={() => updatePage(1)}
              className='px-2 py-1 rounded hover:bg-gray-200 disabled:opacity-50'
              disabled={isLoading}
            >
              <i className='fa-solid fa-angles-left text-gray-800'></i>
            </button>
          </li>

          {/* Previous page */}
          <li>
            <button
              onClick={() =>
                updatePage(
                  pagination.page_number > 1 ? pagination.page_number - 1 : pagination.page_number
                )
              }
              className='px-2 py-1 rounded hover:bg-gray-200 disabled:opacity-50'
              disabled={isLoading}
            >
              <i className='fa-solid fa-angle-left text-gray-800'></i>
            </button>
          </li>

          {/* Ellipsis before */}
          {pagination.page_number > 1 && (
            <li>
              <span className='px-2 py-1 text-gray-500'>...</span>
            </li>
          )}

          {/* Page numbers */}
          {ls2.map((link, i) => (
            <li key={i}>
              <button
                onClick={() => updatePage(link + 1)}
                className={clsx(
                  'px-3 py-1 rounded',
                  pagination.page_number === link + 1
                    ? 'bg-primary text-white'
                    : 'hover:bg-gray-200 text-gray-800',
                  isLoading && 'opacity-50 cursor-not-allowed'
                )}
                disabled={isLoading}
              >
                {link + 1}
              </button>
            </li>
          ))}

          {/* Ellipsis after */}
          {pagination.page_number < paginationList && (
            <li>
              <span className='px-2 py-1 text-gray-500'>...</span>
            </li>
          )}

          {/* Next page */}
          <li>
            <button
              onClick={() =>
                updatePage(
                  pagination.page_number < paginationList
                    ? pagination.page_number + 1
                    : pagination.page_number
                )
              }
              className='px-2 py-1 rounded hover:bg-gray-200 disabled:opacity-50'
              disabled={isLoading}
            >
              <i className='fa-solid fa-angle-right text-gray-800'></i>
            </button>
          </li>

          {/* Last page */}
          <li>
            <button
              onClick={() => updatePage(paginationList)}
              className='px-2 py-1 rounded hover:bg-gray-200 disabled:opacity-50'
              disabled={isLoading}
            >
              <i className='fa-solid fa-angles-right text-gray-800'></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}
